module.exports = __webpack_public_path__ + "img/ico_ugc_txt_long.d2b4fff.svg";